import script from "./EmailSentTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailSentTable.vue?vue&type=script&setup=true&lang=js"

import "./EmailSentTable.vue?vue&type=style&index=0&id=a71396f8&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a71396f8"]])

export default __exports__